import styled, { keyframes } from 'styled-components';

const zoomIn = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}`;

export const PopupIntroWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  pointer-events: auto;
  transition: all 1s ease-out;
  opacity: 1;
  &.inactive {
    pointer-events: none;
    transform: scale(1.1);
    opacity: 0;
    z-index: -1;
    img,
    video {
    }
    .overlayClose {
      display: none;
    }
  }

  img,
  video {
    background-color: #000;
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* pointer-events: none; */
  }

  img {
    animation: ${zoomIn} 2s forwards;
  }

  .--mobile {
    display: none;
  }

  @media (max-width: 640px) {
    .--mobile {
      display: block;
    }
    .--pc {
      display: none;
    }
  }

  .overlayClose {
    position: absolute;
    bottom: 1.5rem;
    left: 0;
    right: 0;
    margin: auto;
    width: max-content;
    z-index: 10;
    .close {
      padding: 4px 32px;
      border: 2px solid #ddd;
      color: #ddd;
      font-weight: 600;
      font-size: 1rem;
      text-align: center;
      transition: all 0.15s ease-out;
      cursor: pointer;
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          background: #ddd;
          color: var(--color-text);
        }
      }
    }
  }
`;
